// extracted by mini-css-extract-plugin
export default {"background":"Header_background__u3kjz","content":"Header_content__lcuvl","titles":"Header_titles__Jq-tn"};